define("shared/components/shared/profile-categorization/rewards-steps/provide-profile-report-data", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/array-methods", "later/utils/number-helpers"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _arrayMethods, _numberHelpers) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _calculateEngagementOnPosts, _processIgHashtags, _getTopUsedHashtags, _calculateHashtagFrequency;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/array-methods",0,"later/utils/number-helpers"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div {{did-update (perform this.performAllTasks) @socialProfile}}>
    {{yield this.yieldedHash}}
  </div>
  */
  {
    "id": "KAhlj0CP",
    "block": "[[[11,0],[4,[38,0],[[28,[37,1],[[30,0,[\"performAllTasks\"]]],null],[30,1]],null],[12],[1,\"\\n  \"],[18,2,[[30,0,[\"yieldedHash\"]]]],[1,\"\\n\"],[13]],[\"@socialProfile\",\"&default\"],false,[\"did-update\",\"perform\",\"yield\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/provide-profile-report-data.hbs",
    "isStrictMode": false
  });

  let ProvideProfileReportDataComponent = (_class = (_calculateEngagementOnPosts = /*#__PURE__*/new WeakSet(), _processIgHashtags = /*#__PURE__*/new WeakSet(), _getTopUsedHashtags = /*#__PURE__*/new WeakSet(), _calculateHashtagFrequency = /*#__PURE__*/new WeakSet(), class ProvideProfileReportDataComponent extends _component2.default {
    get socialProfile() {
      return this.args.socialProfile;
    }

    get followerCount() {
      return this.args.socialProfile.followedBy;
    }

    get allTasksAreLoading() {
      return this.performAllTasks.isRunning;
    }

    get profilePostsIsLoading() {
      return this.categorizationRewards.getProfilePosts.isRunning;
    }

    get getProfilePostsResult() {
      return this.categorizationRewards.getProfilePosts.lastSuccessful?.value ?? undefined;
    }

    get profileHashtagsIsLoading() {
      return this.categorizationRewards.getProfileHashtags.isRunning;
    }

    get getProfileHashtagsResult() {
      return this.categorizationRewards.getProfileHashtags.lastSuccessful?.value ?? undefined;
    }

    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _calculateHashtagFrequency);

      _classPrivateMethodInitSpec(this, _getTopUsedHashtags);

      _classPrivateMethodInitSpec(this, _processIgHashtags);

      _classPrivateMethodInitSpec(this, _calculateEngagementOnPosts);

      _initializerDefineProperty(this, "categorizationRewards", _descriptor, this);

      _initializerDefineProperty(this, "instagram", _descriptor2, this);

      _defineProperty(this, "minimumPostsRequired", 10);

      _defineProperty(this, "minimumHashtagsRequired", 1);

      _defineProperty(this, "performAllTasks", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.socialProfile.isBusiness || this.socialProfile.isCreator) {
            const getProfilePosts = this.categorizationRewards.getProfilePosts.linked().perform(this.socialProfile);
            const getProfileHashtags = this.categorizationRewards.getProfileHashtags.linked().perform(this.socialProfile);
            yield getProfilePosts;
            yield getProfileHashtags;
          }
        }
      }), null, "performAllTasks", null));

      this.performAllTasks.perform();
    } // Note: template hash helper does not consistently trigger autotracking


    get yieldedHash() {
      return {
        isLoading: this.allTasksAreLoading,
        averageProfileEngagement: this.averageProfileEngagement,
        profileHashtags: this.profileHashtags,
        hasEnoughPosts: this.hasEnoughPosts,
        hasEnoughHashtags: this.hasEnoughHashtags
      };
    }

    get profilePosts() {
      return this.profilePostsIsLoading ? [] : this.getProfilePostsResult;
    }

    get hasEnoughPosts() {
      return Boolean(this.profilePosts && this.profilePosts.length >= this.minimumPostsRequired);
    }

    get averageProfileEngagement() {
      if (!this.profilePosts) {
        return;
      }

      const engagementOnPosts = _classPrivateMethodGet(this, _calculateEngagementOnPosts, _calculateEngagementOnPosts2).call(this, this.profilePosts, this.followerCount);

      if (!engagementOnPosts) {
        return;
      }

      const averageProfileEngagement = (0, _arrayMethods.calculateAverage)(engagementOnPosts) * 100;
      return (0, _numberHelpers.preciseRound)(averageProfileEngagement, 3);
    }

    get profileHashtags() {
      if (!this.getProfileHashtagsResult) {
        return;
      }

      return _classPrivateMethodGet(this, _processIgHashtags, _processIgHashtags2).call(this, this.getProfileHashtagsResult);
    }

    get hasEnoughHashtags() {
      return Boolean(this.profileHashtags && this.profileHashtags.length >= this.minimumHashtagsRequired);
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "categorizationRewards", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = ProvideProfileReportDataComponent;

  function _calculateEngagementOnPosts2(posts, currentFollowerCount) {
    if (!this.instagram.isIgPostArray(posts)) {
      return;
    }

    return posts.map(post => {
      const likeCount = post.likeCount || 0;
      const commentCount = post.commentCount || 0;
      const followerCount = post.followersOnPost || currentFollowerCount;

      if (!followerCount) {
        return 0;
      }

      return (likeCount + commentCount) / followerCount;
    });
  }

  function _processIgHashtags2(hashtagData) {
    const frequencyOfEachHashtag = _classPrivateMethodGet(this, _calculateHashtagFrequency, _calculateHashtagFrequency2).call(this, hashtagData);

    const topTenUsedHashtags = _classPrivateMethodGet(this, _getTopUsedHashtags, _getTopUsedHashtags2).call(this, frequencyOfEachHashtag, 10);

    return topTenUsedHashtags.map(tag => `#${tag}`);
  }

  function _getTopUsedHashtags2(frequencyOfEachHashtag, numberOfHashtags) {
    return Object.keys(frequencyOfEachHashtag).sort((a, b) => frequencyOfEachHashtag[a] - frequencyOfEachHashtag[b]).reverse().slice(0, numberOfHashtags);
  }

  function _calculateHashtagFrequency2(hashtags) {
    return hashtags.reduce((previous, current) => {
      previous[current] = (previous[current] || 0) + 1;
      return previous;
    }, {});
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProvideProfileReportDataComponent);
});